import { render, staticRenderFns } from "./ProfileUpdate.vue?vue&type=template&id=5ac2b20b&scoped=true&"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUpdate.vue?vue&type=style&index=0&id=5ac2b20b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2b20b",
  null
  
)

export default component.exports